import { Subject } from 'rxjs';

export class SelectionModel<T> {
  private selection = new Set<T>();

  readonly changed: Subject<T[]> = new Subject();

  select(...values: T[]): void {
    values.forEach((value) => this.markSelected(value));
    this.emitChange();
  }

  deselect(...values: T[]): void {
    values.forEach((value) => this.unmarkSelected(value));
    this.emitChange();
  }

  isSelected(value: T): boolean {
    return this.selection.has(value);
  }

  toggle(value: T): void {
    this.isSelected(value) ? this.deselect(value) : this.select(value);
  }

  selectAll(...values: T[]): void {
    values.forEach((v) => this.markSelected(v));

    this.emitChange();
  }

  deselectAll(): void {
    this.selection.clear();

    this.emitChange();
  }

  toggleMultiple(values: T[]): void {
    values.forEach((v) => {
      this.isSelected(v) ? this.selection.delete(v) : this.selection.add(v);
    });

    this.emitChange();
  }

  count(): number {
    return this.selection.size;
  }

  getAll(): T[] {
    return Array.from(this.selection.values());
  }

  private emitChange() {
    this.changed.next(this.getAll());
  }

  private markSelected(value: T) {
    if (!this.isSelected(value)) {
      this.selection.add(value);
    }
  }

  private unmarkSelected(value: T) {
    if (this.isSelected(value)) {
      this.selection.delete(value);
    }
  }
}
